package com.voter.common

object Constants {
    const val MIN_RATING = 0
    const val MAX_RATING = 5
    
    object Routes {
        const val CREATE_POLL = "/api/polls"
        const val GET_POLL = "/api/polls/{id}"
        const val VOTE = "/api/polls/{id}/vote"
        const val UPDATE_POLL_STATUS = "/api/polls/{id}/status"
        const val POLL_STATUS = "/api/polls/{id}/status"
    }
    
    object Strings {
        const val APP_TITLE = "STAR Voting"
        const val CREATE_POLL_TITLE = "Create New Poll"
        const val VOTE_TITLE = "Cast Your Vote"
        const val ADMIN_PANEL_TITLE = "Admin Panel"
        const val POLL_STATUS_TITLE = "Poll Status"
        
        const val OPTION_TITLE_LABEL = "Option Title"
        const val OPTION_DESCRIPTION_LABEL = "Description (Optional)"
        const val OPTION_URL_LABEL = "URL (Optional)"
        const val VOTER_NAME_LABEL = "Your Name"
        const val POLL_TITLE_LABEL = "Poll Title"
        const val POLL_DESCRIPTION_LABEL = "Poll Description (Optional)"
        
        const val CREATE_BUTTON = "Create Poll"
        const val SUBMIT_VOTE_BUTTON = "Submit Vote"
        const val ADD_OPTION_BUTTON = "Add Option"
        const val REMOVE_OPTION_BUTTON = "Remove"
        const val START_POLL_BUTTON = "Start Poll"
        const val END_POLL_BUTTON = "End Poll"
        
        const val RATING_LABEL = "Rating (0-5 stars)"
        const val POLL_NOT_STARTED = "Poll has not started yet"
        const val POLL_IN_PROGRESS = "Poll is currently in progress"
        const val POLL_ENDED = "Poll has ended"
        
        const val VOTERS_COUNT_LABEL = "Voters who have participated:"
        const val WINNER_LABEL = "Winner:"
        const val PREFERENCE_COUNT_LABEL = "voters preferred this over the second choice"
        const val AVERAGE_RATINGS_LABEL = "Average Star Ratings:"
    }
    
    object Colors {
        const val PRIMARY = "#2563eb"
        const val PRIMARY_DARK = "#1d4ed8"
        const val SECONDARY = "#64748b"
        const val BACKGROUND = "#0f172a"
        const val SURFACE = "#1e293b"
        const val SURFACE_VARIANT = "#334155"
        const val ON_BACKGROUND = "#f1f5f9"
        const val ON_SURFACE = "#e2e8f0"
        const val SUCCESS = "#10b981"
        const val WARNING = "#f59e0b"
        const val ERROR = "#ef4444"
    }
    
    object Spacing {
        const val XS = "4px"
        const val SM = "8px"
        const val MD = "16px"
        const val LG = "24px"
        const val XL = "32px"
        const val XXL = "48px"
    }
}
